/**
 * Warns before a browser refresh / tab close throws away a sale in progress.
 *
 * On Android the Redux store lives as long as the app, so a cart is never lost
 * by accident. In a browser, F5, Ctrl+W or a stray Back to another site
 * destroys the store - and with it the cart (NewSellscreenSlice is not
 * persisted). While anything is in a cart, the browser's own "Leave site?"
 * confirmation is requested instead. Signed-in sessions survive the refresh
 * (sessionStore.web.ts); only the cart does not.
 *
 * Electron shows no dialog for this on its own - electron/main.js answers
 * `will-prevent-unload` with a Leave / Stay prompt.
 */

import {store} from '../../redux/store';

function hasSaleInProgress(): boolean {
  const state = store.getState();
  if (!state?.common?.isLoggedIn) {
    return false;
  }
  const carts = state?.NewSellscreenSlice?.cartProducts ?? {};
  return Object.values(carts).some(lines => Array.isArray(lines) && lines.length > 0);
}

export function installUnsavedSaleGuard(): void {
  window.addEventListener('beforeunload', event => {
    if (!hasSaleInProgress()) {
      return;
    }
    event.preventDefault();
    // Older Chromium (and Electron) still need returnValue set.
    event.returnValue = '';
  });
}
